import React from "react"

import FancyText from "@fuse/sharedComponents/typography/FancyText"

import { testimonial } from "./constant"
import "./style.css"

const Card = ({ title, author }: { title: string; author: string }) => {
  const titleStyle: React.CSSProperties = {
    color: "#fff",
    fontWeight: "500",
    marginBottom: 15,
    fontFamily: "DM Sans",
  }
  const authorStyle: React.CSSProperties = {
    color: "#a89cff",
    fontWeight: "700",
    fontSize: 14,
    fontFamily: "DM Sans",
    letterSpacing: 2,
  }
  return (
    <div className="text-start">
      <FancyText style={titleStyle} className="text-[16px] md:text-[22px]">
        {title}
      </FancyText>
      <FancyText style={authorStyle}>{author}</FancyText>
    </div>
  )
}

export default function DeviceTestimonial() {
  const divStyle: React.CSSProperties = {
    alignItems: "center",
    width: "100%",
    paddingTop: "78px",
    paddingBottom: "78px",
    alignSelf: "stretch",
    background: "linear-gradient(98deg, #6C63FF 0%, #B592FF 100%)",
  }

  return (
    <div
      style={divStyle}
      className="flex-1 items-center justify-center px-[30px] md:flex"
    >
      {testimonial.map((val, index) => (
        <div
          key={index.toString()}
          className={`background-container w-full md:w-[458px] ${
            index === 0 && "mb-[80px] md:mb-0 mr-[50px]"
          }`}
        >
          <Card title={val.name} author={val.authod} />
        </div>
      ))}
    </div>
  )
}
